import { State } from "./store"
import { DeepPartial } from "@/redux/transportation-report.slice"
import { TransportationReport } from "@/model/transportation-report/transportation-report"

export const isDialogOpen
    = (store: State): boolean => store.transportationReport.dialog.open

export const getDialogInitialValues
    = (store: State): DeepPartial<TransportationReport> => store.transportationReport.dialog.initialValues